import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "../components/ui/card";
import { Loader2, Bell } from "lucide-react";

export default function ParentNotifications() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/notifications").then((r) => setItems(r.data.notifications)).finally(() => setLoading(false));
    }, []);

    if (loading) return <div className="flex justify-center py-20"><Loader2 className="h-8 w-8 animate-spin text-primary" /></div>;

    return (
        <div className="space-y-6 max-w-3xl" data-testid="parent-notifications-page">
            <div>
                <div className="text-xs uppercase tracking-wider text-muted-foreground">Updates</div>
                <h1 className="font-heading text-3xl font-black tracking-tight mt-1">Notifications</h1>
                <p className="text-muted-foreground mt-1">School-wide announcements from your child&apos;s teachers.</p>
            </div>
            {items.length === 0 && (
                <div className="text-center py-16 border border-dashed border-border rounded-3xl">
                    <Bell className="h-10 w-10 mx-auto text-muted-foreground mb-2" />
                    <p className="text-sm text-muted-foreground">No notifications yet. Check back soon!</p>
                </div>
            )}
            <div className="space-y-4">
                {items.map((n) => (
                    <Card key={n.id} className="rounded-2xl" data-testid={`notification-${n.id}`}>
                        <CardHeader>
                            <CardTitle className="font-heading text-xl">{n.title}</CardTitle>
                            <CardDescription>{new Date(n.created_at).toLocaleString()}</CardDescription>
                        </CardHeader>
                        <CardContent>
                            <div className="notif-prose text-sm" dangerouslySetInnerHTML={{ __html: n.content }} />
                        </CardContent>
                    </Card>
                ))}
            </div>
        </div>
    );
}
